import type { ReactNode } from 'react';
import { EMPTY_VALUE } from '@/constants/app.constants';

interface LabelWithValueProps {
  label: ReactNode;
  children: ReactNode;
}

export function LabelWithValue({ label, children }: LabelWithValueProps) {
  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-muted-foreground">{label}</p>
      <div className="text-sm font-medium wrap-break-word">
        {children || children === 0 ? children : EMPTY_VALUE}
      </div>
    </div>
  );
}
